import React, { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { Input } from '_components';
import Countdown from './Countdown';

const animation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 500px;
  margin: auto;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  animation: ${animation} 2s;
`;

const Container2 = styled.div`
  width: 100%;
  margin: auto;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  animation: ${animation} 2s;
`;

const VerifyMessageBox = styled.p`
  text-align: center; 
  font-family: Roboto,sans-serif;
  font-size: 15px;
  animation: ${animation} 2s;
`;

const InlineButton = styled.button`
  display: inline;
  background: none;
  border: none;
  cursor: pointer;
  color: #185D72;
  ${(props) => props.disabled && css`
    cursor: not-allowed;
  `}
`;

function Verification({
  formData, goBack, resend, setLoading
}) {
  const {
    method, email, sms, phone
  } = formData;
  let target = email;
  if (method === 'phone') {
    target = phone;
  } else if (method === 'sms') {
    target = sms;
  }
  const message = `Please enter the 6-digit verification code that is sent to ${target}`;
  const { register } = useFormContext();
  const [verifyMessage, setVerifyMessage] = useState(message);
  const [pinCount, setPinCount] = useState(0);
  const [canResend, setCanResend] = useState(false);

  const onResend = async () => {
    if (!canResend) {
      return;
    }
    setLoading(true);
    const result = await resend();
    setLoading(false);
    if (result) {
      setVerifyMessage('We sent the pin again!');
      setPinCount(pinCount + 1);
    } else {
      setVerifyMessage('There was a problem in resending the code. Please try again later.');
    }
  };

  return (
    <div>
      <VerifyMessageBox>
        {verifyMessage}
      </VerifyMessageBox>
      <Container>
        <Input
          placeholder="Enter the 6-digit code you received"
          ariaLabel="Enter the 6-digit code you received"
          maxLength={6}
          inputRef={register({ pattern: /[0-9]{6}/g })}
          name="pin"
          autoFocus
          style={{ width: '100%' }}
        />
        <p />
      </Container>
      <Container2>
        Not received the code?
        <InlineButton type="button" onClick={goBack}>Try another email/number</InlineButton>
        {!pinCount && ' or '}
        {!pinCount && (
          <InlineButton type="button" onClick={onResend} disabled={!canResend}>
            <span>we can resend </span>
            <Countdown interval={60} onFinished={() => setCanResend(true)} />
          </InlineButton>
        )}
      </Container2>

    </div>
  );
}

export default Verification;
